import { render, staticRenderFns } from "./cg-event-teaser-date.vue?vue&type=template&id=5a3c5e5b&scoped=true"
import script from "./cg-event-teaser-date.vue?vue&type=script&lang=js"
export * from "./cg-event-teaser-date.vue?vue&type=script&lang=js"
import style0 from "./cg-event-teaser-date.vue?vue&type=style&index=0&id=5a3c5e5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3c5e5b",
  null
  
)

export default component.exports